module.exports = __webpack_public_path__ + "img/100.87b75446.svg";